import { render, staticRenderFns } from "./UserNotificationDetail.vue?vue&type=template&id=05915278&scoped=true"
import script from "./UserNotificationDetail.vue?vue&type=script&lang=js"
export * from "./UserNotificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05915278",
  null
  
)

export default component.exports